// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// Bootstrap Imports
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

export default function ResellerDiscount() {
   const state = useQuoteContext()
   const { getString } = state
   const permissions = state.featurePermissions['ResellerDiscount']

   // list of possible reseller discounts
   let reseller_discount_list = [
      { value: 0, name: 0 },
      { value: 20, name: 20 },
      { value: 25, name: 25 },
      { value: 30, name: 30 },
      { value: 35, name: 35 },
   ]

   if (
      permissions.includes(state.user_role) &&
      (state.user_view == 'Internal' || state.discountReseller > 0)
   )
      return (
         <InputGroup className='justify-content-center' size='sm'>
            <InputGroup.Text size='sm'>
               {getString('product.ResellerDiscount.InputText')}
            </InputGroup.Text>
            <Form.Select
               defaultValue={state.discountReseller}
               onChange={(e) => {
                  state.setDiscountReseller(e.target.value)
               }}
            >
               {reseller_discount_list.map((e, key) => {
                  return (
                     <option key={key} value={e.value}>
                        {e.name}
                     </option>
                  )
               })}
            </Form.Select>
         </InputGroup>
      )
}
